import * as React from 'react';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import VenueLink from 'components/Venue/VenueLink.tsx'
import VenueMapLink from 'components/Venue/VenueMapLink.tsx';


export default function CeremonyDetails() {
  return (
    <Container sx={{
      display: 'flex',
      width: '100%',
    }}>
      <List sx={{ width: '100%' }}>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography variant="body2" component="span">
                  <p>Join us as we say "I do" in front of the Charles river.</p>
                  <p>There will be free parking in the museum's garage. The museum is located directly across from the Green Line "Science Park" T stop and a short 8 minute walk from the Kimpton Marlow.</p>
                  <p>Enter through the main entrance of the museum. The venue is covered and outdoors. When choosing footwear, expect a mixture of pavement and grass.</p>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider component="li" />
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Location
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography component="span" sx={{fontSize: 16, fontWeight: "bold"}}><VenueLink underline='always' linkText='Museum of Science' /></Typography>
                <Typography variant="body2"><VenueMapLink /></Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Parking
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2">Free parking at the Museum's Garage</Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Venue Info
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2">
                  <Link href="/venue" underline='always'>More Info Here</Link>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Dress Code
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2">
                  <Link href="https://www.theknot.com/content/cocktail-wedding-attire">Colorful Cocktail Attire</Link>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </Container>
  );
}
